module.exports = __webpack_public_path__ + "packs/media/images/Warum_MM_2-7d8ccea5cb84accf75eea134a3f8b35e.jpg";